import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const RejectButton = (props) => {
  const { handleVerified, btnName } = props;
  return (
    <>
      <button
        className="btn btn-light"
        style={{
          fontSize: "13px",
          backgroundColor: " rgb(253, 226, 226)",
          color: " rgb(193,64,80)",
          // paddingTop: "6px",
          // paddingBottom: "3px",
          // marginTop: "0px",
          // marginBottom: "0px",
          // paddingRight: "2px",
          // paddingLeft: "1px",
          // width: "76px",
          // borderRadius: 0,
          // fontFamily: "emoji",
          // fontWeight: "700",
          //   border: "1px solid",
        }}
        onClick={handleVerified}
      >
        <FontAwesomeIcon icon={faXmark} className="me-1" />
        <span className="">{btnName ? btnName : "Reject"}</span>
      </button>
    </>
  );
};

export default RejectButton;
